import React, { useContext } from 'react'
import PropTypes from "prop-types"
import { RichText } from 'prismic-reactjs'
import { ThemeProvider } from "styled-components"
import { Background } from 'react-imgix'

import { getLinkPropsFromReference } from '../../utils/link'
import { RichLinks, RichContent } from '../../utils/html'

import { THEME_BLACK, THEME_GREY } from '../../theme/theme'
import { getColor } from  '../../theme/colors'

import PageMetaContext from '../../context/page-meta-context';

import SectionContainer from '../section-container'
import ResponsiveImage from '../responsive-image'

import { Container, Heading, Inner, Content, Center, Label, Buttons, ImageContainer } from './promo.styles'


const Promo = ({heading,label,links,background,background_color,overlap,overlapSmall,condenseTop,condenseBottom,count}) => {
	const meta = useContext(PageMetaContext);
	return (
		<ThemeProvider theme={(theme) => ({...theme,...THEME_GREY})}>
			<SectionContainer condenseTop={condenseTop} condenseBottom={condenseBottom} overlap={overlap} overlapSmall={overlapSmall}>
				<Inner backgroundColor={getColor(background_color)}>
					<ImageContainer>
						{background && <ResponsiveImage image={background} fit="cover" mobileFit="cover" lazy sizes={{medium:{span:12}}} sizeOptions={{defaultSize:`100vw`}} />}
					</ImageContainer>
					<ThemeProvider theme={(theme) => ({...theme,...THEME_BLACK})}>
						<Content>
							<Center>
								<Label>{label}</Label>
								<Heading><RichContent render={heading} /></Heading>
								<Buttons><RichLinks render={links} block="promo" meta={meta} /></Buttons>
							</Center>
						</Content>
					</ThemeProvider>
				</Inner>
			</SectionContainer>
		</ThemeProvider>
	)
}

export default Promo;